<template>
    <div>
        <div class="border-gray-300 border-b py-3 px-4">
            <div class="flex justify-between text-xl md:text-2xl text-blue-700">
                <span>{{ title }}</span>
                <button @click="isOpen = !isOpen" class="w-9 h-9 flex justify-center items-center">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="w-6 h-6 transform duration-150" :class="{'rotate-45 text-red-400': isOpen, 'text-blue-500': !isOpen}">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v3m0 0v3m0-3h3m-3 0H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                </button>
            </div>
            <div class="text-lg text-blue-700 mt-2" v-show="isOpen">
                <slot></slot>
            </div>

        </div>

    </div>

</template>

<script>
export default {
    name: "Accordion",
    props: ['title','isLast'],
    data: function(){
        return {
            isOpen: false
        }
    }
};
</script>

<style scoped>

</style>
